import { ChangeDetectorRef,Component, OnInit,TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/_services/common.service';
import { CommonUtility } from 'src/app/_modules/commonUtility';
import { SweetAlertService } from 'src/app/_services/sweet-alert.service';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'src/app/_services/local-storage.service';


@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})

export class LoginComponent implements OnInit {

  verifyButton: Boolean = true;
  loginForm: FormGroup;
  verifyloginFrm: FormGroup;
  hidePasswordDiv: boolean = false;
  initialCap: any;
  dataVisable: boolean = false;
  sumbitbtn: boolean = true;
  ErrorMsg: boolean;
  passwordErr: any;
  AuthTokenValue;
  decodedToken;
  commonUtil: CommonUtility;
  dialogRef
  bankName: any;
  @ViewChild('editDialogue', { static: true }) editDialogue: TemplateRef<any>;

  constructor(private sweetalert: SweetAlertService, private router: Router,
    private formBuilder: FormBuilder, private commonService: CommonService,
    private ref: ChangeDetectorRef,
    private dialog: MatDialog, private _activatedRoute: ActivatedRoute,private localStorage: LocalStorageService) { 
      this.commonUtil = this.commonService.commonUtility;
    }

  ngOnInit(): void {
    this.initVerifyloginFrm();
    this.Cap();
    this.bankName = this._activatedRoute.snapshot.params.bankName;
    //localStorage.setItem('bankName', this.bankName);
    this.localStorage.setBankName(this.bankName);
  }

   onSubmit() {
    if (this.loginForm.invalid) {
      console.log('Form is invalid'); 
      return;
    }
    this.router.navigate(["/dashboard"])
  }

  verifyUserName() {
    let userName = this.verifyloginFrm.get('userName').value;
    var confirm = ""

    console.log("userName", userName);
    if (userName != '') {
      console.log("userName", userName);

      let req = this.verifyloginFrm.get('userName').value;
      console.log("req", req);

      this.commonService.getUserIdwithToken(req, confirm).subscribe(res => {
        if (res['body']['statusDesc'] == "User login.") {
          localStorage.setItem('userId', res["body"]["data"]["userId"]);
          this.hidePasswordDiv = true;
          this.verifyButton = false;
          this.initLoginForm();
        }
        else {
          let msg = '';
          if (res['body']['statusDesc'] == 'Invalid username.') { msg = 'Invalid username.' }
          else if (res['body']['statusDesc'] == 'Your last session was terminated incorrectly or is currently active. Please try logging in again after some time.') { msg = 'Your last session was terminated incorrectly'; }
          else {
            this.sweetalert.confirmation('You are already logged in from another system or not logged out properly. If you continue you will be logged out from that system.', (confirmed) => {
              if (confirmed) {

                var confirm = "Y"
                this.commonService.getUserIdwithToken(req, confirm).subscribe(res => {
                  if (res['body']['statusDesc'] === "User login.") {
                    localStorage.setItem('userId', res["body"]["data"]["userId"]);

                    console.log("Response:::", res["body"]["data"]["userId"])
                    this.hidePasswordDiv = true;
                    this.verifyButton = false;
                    this.initLoginForm();
                  }
                });

              } else {
                var confirm = ""
                this.commonService.getUserIdwithToken(req, confirm).subscribe(res => {
                  if (res['body']['statusDesc'] === "User login.") {
                    localStorage.setItem('userId', res["body"]["data"]["userId"]);
                    this.hidePasswordDiv = true;
                    this.verifyButton = false;
                    this.initLoginForm();
                  }
                });
              }
            });
            //   this.verifyloginFrm.controls['userName'].setErrors({ incorrect: msg});
          }
        }
      });
    }

  }

  ngAfterViewChecked() {
    this.ref.detectChanges();
  }
  hidePasswordDivFuntn() {
    this.hidePasswordDiv = false;
    this.verifyButton = true;
  }
  initVerifyloginFrm() {
    this.verifyloginFrm = this.formBuilder.group({
      'userName': ['', Validators.required]
    });
  }
  initLoginForm() {
    this.loginForm = this.formBuilder.group({
      'password': ['', Validators.required],
      'captcha': ['', Validators.required],
    });
  }

  ValidCaptcha() {
    let str1 = this.initialCap
    let str2 = this.loginForm.get('captcha').value;
    if (str2.toUpperCase() != "") {
      if (str1 == str2.toUpperCase()) {
        this.loginForm.controls['captcha'].setErrors(null);
        return true;
      } else {
        this.loginForm.controls['captcha'].setErrors({ 'incorrectcaptcha': true });
        return false;
      }
    }
    else {
    }
  }

  Cap() {
    let alpha = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var apl1 = alpha[Math.floor(Math.random() * 36)];
    var apl2 = alpha[Math.floor(Math.random() * 36)];
    var apl3 = alpha[Math.floor(Math.random() * 36)];
    var apl4 = alpha[Math.floor(Math.random() * 36)];
    var apl5 = alpha[Math.floor(Math.random() * 36)];
    var apl6 = alpha[Math.floor(Math.random() * 36)];
    this.initialCap = apl1 + apl2 + apl3 + apl4 + apl5 + apl6;

  }

  SubmitVisible() {
    let pass = this.loginForm.get('password').value;
    let cap = this.loginForm.get('captcha').value;
    let userName = this.verifyloginFrm.get('userName').value;
    if (userName && pass && cap && cap.length == 6) {
      return false;
    }
    else {
      return true;
    }
  }

  showVerify() {
    let userName = this.verifyloginFrm.get('userName').value;
    if (userName != '') {
      return false;
    }
    else {

      return true;
    }
  }

  Login2FA() {

    if (this.ValidCaptcha() == true) {
      let req = {

        userName: this.verifyloginFrm.value.userName,
        password: ('' + this.commonService.passEncry(this.loginForm.value.password, localStorage.getItem('userId')))
      }
      this.commonService.Login2FA(req).subscribe(res => {
        if (res['body']['statusCode'] == "R001") {
          localStorage.setItem('userName', this.verifyloginFrm.value.userName);
          localStorage.setItem('authorizationToken', res['body']['data']['token'])
          this.sumbitbtn = false;
          this.decodedToken = this.commonService.decodeToken(res['body']['data']['token']);
          localStorage.setItem('roleId', this.decodedToken.roleId);
          localStorage.setItem('userId', this.decodedToken.userId);
          localStorage.setItem('roleName', this.decodedToken.roleName);
          localStorage.setItem('zoneName', this.decodedToken.zoneName);
          localStorage.setItem('branchId', this.decodedToken.branchId);
          localStorage.setItem('departmentId', this.decodedToken.departmentId);
          localStorage.setItem('bankId', this.decodedToken.bankId);
          //const bankName = localStorage.getItem('bankName');
          this.router.navigate(['/dashboard']);
        } else if (res['body']['statusCode'] == "E001") {
          this.ErrorMsg = true;
          this.passwordErr = res['body']['statusDesc'];
          setTimeout(() => {
            this.ErrorMsg = false;
          }, 5000)
        }
        else {
          this.sumbitbtn = true;
          // this.commonUtil.alertMsg(res['body']['statusDesc'],'',false);
          this.sweetalert.errorAlert('Error', res['body']['statusDesc'],false)
          this.Cap();
        }
      },
        (error) => {
          this.Cap();
          //  this.commonUtil.alertMsg('Internal Server error','',false);
          this.sweetalert.errorAlert('Error', 'Internal Server error')
          //this.sweetalert.errorAlert('Error','You are already logged in from another system')
          //this.router.navigate([''])
        });
      this.Cap();
    }
  }

}
